angular.module('iqxCore')
	.service('ApiSvc', function ($http, $filter, $q, ApplicationSvc, $rootScope, SweetAlert, ErrorReporterSvc) {
		var svc = this

		svc.StringToDate = function (sDate) {
			if (sDate) { // Looking for ISO format or UK format with 4 digit year and any separator (may be prefixed by alpha day of week)
				var ar
				ar = sDate.match(/(^\d{4}).(\d+).(\d+)/)
				if (ar && ar.length >= 4) {
					return new Date(ar[1], ar[2] - 1, ar[3])
				}
				ar = sDate.match(/(\d+).(\d+).(\d{4})/)
				if (ar && ar.length >= 4) {
					return new Date(ar[3], ar[2] - 1, ar[1])
				}
			}
			return null
		}

		svc.StringToTime = function (sTime) {
			if (sTime) {
				var ar = sTime.match(/^(\d{1,2})[:](\d{2})/)
				if (ar.length < 3) { return null }
				var d = new Date()
				d.setHours(ar[1])
				d.setMinutes(ar[2])
				return d
			} else {
				return null
			}
		}

		svc.TimeToString = function (dTime) {
			return $filter('date')(dTime, 'HH:mm')  // HH for 24 hour
		}

		svc.DateToString = function (dDate) {
			return $filter('date')(dDate, 'dd/MM/yyyy')
		}

		svc.StringToMoment = function (sDate) {
			if (sDate) { // Looking for ISO format
				var theMoment = moment(sDate)
				if (theMoment.isValid()) {
					return theMoment
				}
			}
			return null
		}

		svc.MomentToString = function (mMoment) {
			return mMoment.toISOString()
		}

		svc.SafeJSONValue = function (val) {
			if (angular.isDate(val)) {
				return svc.DateToString(val)
			} else if (moment.isMoment(val)) {
				return svc.MomentToString(val)
			} else if (typeof val == 'boolean') {
				return (val ? 1 : 0)
			} else {
				return val
			}
		}

		svc.ValuesAreEqual = function (x, y) {
			if (angular.isDate(x) && angular.isDate(y)) {
				return (x.getTime() == y.getTime())
			} else {
				return (x === y)
			}
		}

		svc.IQXResultSucceeded = function (rowData, bLiteral) {
			var x = { IQXResult: { attrs: { success: 1 }, Row: rowData } }    // Construct a successful IQXResult with the rowData supplied
			if (bLiteral) {
				return x  // return an object which can be used as the data in an $httpbackend respond
			} else {
				return $q.when({ data: x })   // return as a fulfilled promise to spoof an $http.get return
			}
		}

		svc.IQXResultFailed = function (errorMessage, bLiteral) {
			var x = { IQXResult: { attrs: { success: 0 }, IQXFailure: { attrs: { message: sMessage } } } }   // Construct a failed IQXResult with the errorMessage supplied
			if (bLiteral) {
				return x  // return an object which can be used as the data in an $httpbackend respond
			} else {
				return $q.when({ data: x })   // return as a fulfilled promise to spoof an $http.get return
			}
		}

		svc.CheckIQXResult = function (data) {
			if (data.IQXResult == undefined) {
				throw { iqxError: { text: 'IQXResult missing', errorNumber: 1 } }
			}
			if (data.IQXResult.attrs.success == '0') {
				var errorNumber = data.IQXResult.IQXFailure.attrs.errornumber || 1
				throw { iqxError: { text: data.IQXResult.IQXFailure.attrs.message, errorNumber: errorNumber } }
			}
		}

		svc.ExtractError = function (err) {
			if (angular.isObject(err)) {
				return err.data || 'Web Server Unavailable'
			} else {
				return err
			}
		}

		function extendedFetchAPI(scope, options) {
			var fetchAPI = options.fetchAPI
			function addParam(name, value) {
				if (fetchAPI.indexOf('?') >= 0) {
					fetchAPI = fetchAPI + '&' + name + '=' + value
				} else {
					fetchAPI = fetchAPI + '?' + name + '=' + value
				}
			}

			if (options.multiRow && options.sliceSize) {
				addParam('pSliceSize', options.sliceSize)
				addParam('pSlice', (scope.currentPage - 1))
			}

			if (options.fetchWithPersonID) {
				addParam('pPersonID', ApplicationSvc.currentUser.personID)
			}
			return fetchAPI
		}

		function safeNumber(n) {
			if ((typeof n) == 'string' && n.indexOf(',') >= 0) {   // European format
				n = n.replace(',', '.')
			}
			return Number(n)
		}

		svc.fetch = function (scope, options) {
			var theResult, doFetch
			if (!options.fetchAPI) { return $q.reject(SweetAlert.swal("Error", "No fetchAPI in options.", "error")) }
			if (!ApplicationSvc.isLoggedIn && !options.notLoggedIn) { return $q.reject(SweetAlert.swal("Error", "Not logged in.", "error")) }
			$rootScope.isRouteLoading = true
			$rootScope.progressbar.start()
			if (angular.isString(options.fetchAPI)) {
				doFetch = $http.get('/api/' + extendedFetchAPI(scope, options))
			} else {
				doFetch = svc.IQXResultSucceeded(options.fetchAPI)
			}
			return doFetch
				.then(function (res) {
					svc.CheckIQXResult(res.data)  // Checks the IQXResult construct and, if failed, calls error reporer, third paramiter is options set (used by error reporter)
					if (options.multiRow) {
						if (res.data.IQXResult.Row == undefined) {
							theResult = []
						} else if (angular.isArray(res.data.IQXResult.Row)) {
							theResult = res.data.IQXResult.Row
						} else {  // Make single row into an array
							theResult = [res.data.IQXResult.Row]
						}
						if (options.sliceSize && theResult.length < options.sliceSize) {
							// Make this the last page
							scope.totalItems = (scope.currentPage - (theResult.length === 0 && scope.currentPage > 1 ? 1 : 0)) * options.sliceSize
						}
					} else {  // Single row expected
						if (res.data.IQXResult.Row == undefined) {
							theResult = {}
						} else if (angular.isArray(res.data.IQXResult.Row)) {  // Extract first row or empty object if none
							theResult = (res.data.IQXResult.Row.length > 0) ? res.data.IQXResult.Row[0] : {}
						} else {
							theResult = res.data.IQXResult.Row
						}
					}
					angular.forEach(options.dateFields, function (value) {
						if (options.multiRow) {
							angular.forEach(theResult, function (row) {
								if (row[value] != undefined) {
									row[value] = svc.StringToDate(row[value])
								}
							})
						} else if (theResult[value] != undefined) {
							theResult[value] = svc.StringToDate(theResult[value])
						}
					})
					angular.forEach(options.timeFields, function (value) {
						if (options.multiRow) {
							angular.forEach(theResult, function (row) {
								if (row[value] != undefined) {
									row[value] = svc.StringToTime(row[value])
								}
							})
						} else if (theResult[value] != undefined) {
							theResult[value] = svc.StringToTime(theResult[value])
						}
					})
					angular.forEach(options.booleanFields, function (value) {
						if (options.multiRow) {
							angular.forEach(theResult, function (row) {
								if (row[value] != undefined) {
									row[value] = (row[value] == 1)
								}
							})
						} else if (theResult[value] != undefined) {
							theResult[value] = (theResult[value] == 1)
						}
					})
					angular.forEach(options.numberFields, function (value) {
						if (options.multiRow) {
							angular.forEach(theResult, function (row) {
								if (row[value] != undefined) {
									row[value] = (safeNumber(row[value]))
								}
							})
						} else if (theResult[value] != undefined) {
							theResult[value] = (safeNumber(theResult[value]))
						}
					})
					angular.forEach(options.momentFields, function (value) {
						if (options.multiRow) {
							angular.forEach(theResult, function (row) {
								if (row[value] != undefined) {
									row[value] = svc.StringToMoment(row[value])
								}
							})
						} else if (theResult[value] != undefined) {
							theResult[value] = svc.StringToMoment(theResult[value])
						}
					})
					if (options.fetchTarget) {
						scope[options.fetchTarget] = theResult
					} else if (options.multiRow) {
						scope.theRecords = theResult
					} else {
						scope.theRecord = theResult
					}
				})
				.catch(function (err) { // catch http error
					return ErrorReporterSvc.report(err, { options: options })
				})
				.finally(function () {
					$rootScope.isRouteLoading = false
					$rootScope.progressbar.complete()
				})
		}

		svc.exec = function (scope, api, postObject, notLoggedIn) {
			$rootScope.isRouteLoading = true
			$rootScope.progressbar.start()
			if (!(ApplicationSvc.isLoggedIn || notLoggedIn)) { return $q.reject(SweetAlert.swal("Error", "Not logged in.", "error")) }
			var postvars = {}
			angular.forEach(postObject, function (value, key) {
				postvars[key] = svc.SafeJSONValue(value)
			})
			return $http.post('/api/' + api, postvars)
				.then(function (res) {
					svc.CheckIQXResult(res.data)  // Checks the IQXResult construct and, if failed, calls error reporting function, third paramiter is options set (used by error reporter)
					return res.data // Promise succeeds - we may want the IQXResult
				})
				.catch(function (err) { // catch http error
					return ErrorReporterSvc.report(err, { api: api }, { postObject: postObject })
				})
				.finally(function () {
					$rootScope.isRouteLoading = false
					$rootScope.progressbar.complete()
				})
		}

	})
